<template>
    <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
        <template slot="header">
            <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Folio</th>
                <th :class="StyleTh">Serie</th>
                <th :class="StyleTh">Fecha Timbrado</th>
                <th :class="StyleTh">Nombre del Cliente</th>
                <th :class="StyleTh">Total</th>
                <th :class="StyleTh">Forma Pago</th>
                <th :class="StyleTh">Facturado</th>
                
            <th :class="StyleTh+' text-center'">Acciones</th>
        </template>

        <template slot="body">
            <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                <td><h6 :class="StylePr">{{lista.Folio}}</h6></td>
                <td><p :class="StyleTd">{{lista.Serie}}</p></td>
                <td><p :class="StyleTd">{{lista.FechaRegistro}}</p></td>
                <td><p :class="StyleTd">{{lista.NombreCliente}}</p></td>
                <td><p :class="StyleTd">{{lista.Total}}</p></td>
                <td><p :class="StyleTd">{{lista.FormaPago}}</p></td>
                <td><p :class="StyleTd">{{lista.Facturado}}</p></td>
                    
                <td class="align-middle text-end">
                    <template v-if="lista.Facturado == 'SI'">
                        <button type="button" @click="CancelarFactura(lista)" class="btn btn-link text-danger text-gradient px-3 mb-0">
                            <i class="far fa-trash-alt me-2" aria-hidden="true"></i>Cancelar
                        </button>
                    </template>

                    <CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="(lista.Facturado == 'NO')?true:false" :pIsModal="false" :pId="lista.IdFactura" :pEmitSeccion="ConfigList.EmitSeccion" :pGoRoute="ConfigList.GoRoute" :segurity="segurity" :pObj="ConfigList.Obj">
                        <template slot="btnaccion">
                            <CMoreButtonsL>
                                <template slot="bodyBtnsL">
                                    <li @click="VerPdfFactura(lista)">
                                        <a class="dropdown-item">
                                            <i class="far fa-file-pdf"></i> Pdf
                                        </a>
                                    </li>

                                    <template v-if="lista.Facturado == 'SI'">
                                        <li @click="DescargarXml(lista)">
                                            <a class="dropdown-item">
                                                <i class="far fa-file-code"></i> Xml
                                            </a>
                                        </li>

                                        <li @click="VerPdfAcuse(lista)">
                                            <a class="dropdown-item">
                                                <i class="far fa-file-pdf"></i> Acuse de Cancelación
                                            </a>
                                        </li>

                                        <li>
                                            <a class="dropdown-item">
                                                <i class="far fa-exclamation-triangle"></i> Acuse de Cancelación
                                            </a>
                                        </li>
                                    </template>
                                </template>
                            </CMoreButtonsL>
                        </template>
                    </CBtnAccion>
                </td>
            </tr>
            <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="9"></CSinRegistros>

            <CModal :pConfigModal="ConfigModal2" :poBtnSave="oBtnSave2">
                <template slot="Form">
                    <FormCancel :poBtnSave="oBtnSave2"></FormCancel>
                </template>
            </CModal>
        </template>
    </CList>

</template>
<script>
import FormCancel from '@/views/modulos/finanzas/facturas/FormCancelar.vue';

import moment from 'moment';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionFactura';
const EmitEjecuta2 = 'seccionRelacionadas';

export default {
    name: 'ListaFactura',
    props:['pObjEnviado','pLugar'],
    components: {
        FormCancel
    },
    data() {
        return {
            ConfigList:{
                Title: 'Cotización: ',
                IsModal: false,
                /*ShowYear: true,*/
                ShowLoader: true,
                BtnReturnShow: true,
                EmitSeccion: EmitEjecuta,
                TitleFirst: 'Facturas',
                GoRoute: 'facturaform',
                Obj: {},
            },
            ConfigModal2:{
                ModalTitle: "Cancelar Facturas",
                ModalNameId: 'ModalForm2',
                EmitSeccion: EmitEjecuta2,
                ModalSize: 'lg',
            },
            oBtnSave2: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
                ShowBtnSave: true,
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            segurity: {},
            
            ListaArrayRows: [],
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            ObjCotizacion: {},
            LugarOrigen: '',
            RutaReturn: '',
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            let objSearch = {
                TxtBusqueda: this.Filtro.Nombre,
                Entrada: this.Filtro.Entrada,
                Pag: this.Filtro.Pagina,
                RegEstatus: 'A',
            };

            if(this.LugarOrigen == 'CotzxFactura')
            {
                objSearch.IdCotizacion = this.ObjCotizacion.IdCotizacion;
            }
            else{
                objSearch.FacturaLibre = 'SI';
            }


            await this.$http.get("facturas",{
                params: objSearch

            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('facturas/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:this.RutaReturn,params:{}});
        },
        CancelarFactura(item)
        {
            let obj = {
                IdDelCFDI: item.IdFactura,
                TipoCancelacion: 'F',
            };
            this.bus.$emit('NewModal_'+EmitEjecuta2,obj);
        },
        VerPdfFactura(item)
        {
            this.ConfigList.ShowLoader = true;

            let newRequest = {
				IdFactura: item.IdFactura
			}

			this.$http.post('rptpdffactura',newRequest).then((res)=>{     
				
				let pdfWindow = window.open("Factura",'Factura_'+item.IdFactura,'_blank');
				pdfWindow.document.write(
					"<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
					encodeURI(res.data.pdf) + "'></iframe>"
				);
                
			}).catch(err=>{   
				console.log(err);
			}).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        VerPdfAcuse(item)
        {
            this.ConfigList.ShowLoader = true;
            
            let newRequest = {
				IdFactura: 17,//item.IdFactura
				TipoDocumento: 'F',
			}

			this.$http.post('rptpdfacuse',newRequest).then((res)=>{     
				
				let pdfWindow = window.open("Acuse",'Acuse de cancelacion_'+item.IdFactura,'_blank');
				pdfWindow.document.write(
					"<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
					encodeURI(res.data.pdf) + "'></iframe>"
				);
			}).catch(err=>{   
				console.log(err);
			}).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        DescargarXml()
        {
            this.ConfigList.ShowLoader = true;
            
            let newRequest = {
				IdFactura: 17,//item.IdFactura
				TipoDocumento: 'F',
			}

			this.$http.post('downloadxmlfactura',newRequest).then((res)=>{     
				
				let pdfWindow = window.open("Acuse",'Acuse de cancelacion_'+item.IdFactura,'_blank');
				pdfWindow.document.write(
					"<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
					encodeURI(res.data.pdf) + "'></iframe>"
				);
			}).catch(err=>{   
				console.log(err);
			}).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
    },
    created()
    {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(Origen){
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }

        console.log(this.pLugar)

        if(this.pLugar != undefined){
            sessionStorage.setItem('objLugar',this.pLugar);
        }

        this.LugarOrigen = sessionStorage.getItem('objLugar');

        // SI EL ORIGEN VIENE DESDE EL CLIENTE
        if(this.LugarOrigen == 'CotzxFactura')
        {
            if(this.pObjEnviado != undefined){
                sessionStorage.setItem('objCotizacion',JSON.stringify(this.pObjEnviado));
            }

            this.ObjCotizacion = JSON.parse(sessionStorage.getItem('objCotizacion'));
            this.ConfigList.Title = this.ConfigList.Title+' '+this.ObjCotizacion.Folio;

            let obj = {
                objCotz: this.ObjCotizacion,
                Lugar: 'CotzxFactura',
            };

            this.ConfigList.Obj = obj;

            this.RutaReturn = 'cotzPendientes';
        }
        else
        {
            sessionStorage.removeItem('objCotizacion');
            this.ConfigList.Title = 'Facturas Libres';

            let obj = {
                objCotz: {},
                Lugar: 'FacturaLibre',
            };

            this.ConfigList.Obj = obj;

            this.RutaReturn = 'panelSubMenus';
        }

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
